import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

import {Location} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { LogisticsService } from 'src/app/Services/Logistics/logistics.service'
import { DatePipe } from '@angular/common'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'



@Component({
  selector: 'app-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.css']
})
export class ScheduleDetailsComponent implements OnInit {

  fullName;
  email;
  phoneNumber;
  branch;
  userschedule=[];
  error=[];
allscheduleDetails=[];
date;
perms=true;
success;
currentUser:User;
username;
userbranch;
role;
pickupTime;

  constructor(private actroute: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private _authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private _logistics: LogisticsService,
    public datepipe: DatePipe) {
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
      this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.userbranch=this.currentUser.branch;
      this.role=this.currentUser.role;
     } }

  ngOnInit(): void {
    this.actroute.paramMap.subscribe(params => {
      // This is never executed, for route is not recognized
      // let myArray=params.getAll('extra');
      const pid = params.get('extra')
      this.fullName = params.get('extra1')
      this.phoneNumber = params.get('extra2');
      this.branch = params.get('extra3');
      this.pickupTime = params.get('extra4');
     // console.log(pid);
      if (pid) {
      //  console.log(this.fullName);
        this.getScheduleToView(pid, this.fullName, this.phoneNumber,this.branch, this.pickupTime);
       
      } else {
        //      this.viewMode=false;
      //  console.log('done');
      }
    });
  }






  getScheduleToView(pid, fullName,phoneNumber,branch, pickupTime) {
    this._logistics.getScheduleDetails(pid, fullName,phoneNumber,branch,pickupTime).subscribe(

      response =>  {
        this.userschedule= response;
        console.log(this.userschedule);
      },
      (err) => {
        this.error = err;
      }
    );
  
  }

editSchedule(schedule){
  //console.log(appointment);
  if(schedule.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:schedule.pid,extra1:schedule.timeIn,extra2:schedule.salesRep,extra3:schedule.branch,extra4:schedule.pickupTime}],{relativeTo:this.actroute});
  }else{
 
 
   this.router.navigate(['../schedule-edit',{extra:schedule.pid,extra1:schedule.fullName,extra2:schedule.phoneNumber,extra3:schedule.branch,extra4:schedule.pickupTime}],{relativeTo:this.actroute});
  }
 }



 
  
 deleteAppointment(list){
  this._logistics.deleteSchedulebypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessDeleteModalButton").click();
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}


 patchCheckIn(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');


}



patchCheckOut(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  
}

  backClicked() {
    this._location.back();
  }



  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }
  
  isReceptionist() {
    return this.currentUser && this.currentUser.role === UserRole.Receptionist;
  }
  
  isSalesRep() {
    return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
  }
  
  isPowerUser() {
    return this.currentUser && this.currentUser.role === UserRole.PowerUser;
  }
}
